import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, Mail, Loader2 } from 'lucide-react';
import Logo from '../components/Logo';
import api from '../lib/api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setError('');
    try {
      const { data } = await api.post('/admin/login', form);
      localStorage.setItem('es_admin_token', data.token);
      if (data.user) localStorage.setItem('es_admin_user', JSON.stringify(data.user));
      navigate('/admin/dashboard');
    } catch (err) {
      const msg =
        err?.response?.status === 401
          ? 'Invalid email or password.'
          : 'Cannot reach the server. Is the API running on port 5000?';
      setError(msg);
      setStatus('idle');
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-ink-950 px-4">
      <div className="aurora absolute inset-0 -z-10 opacity-60" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="glass w-full max-w-md p-8"
      >
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <Logo showText={false} />
          <h1 className="font-display text-2xl font-bold">Admin Panel</h1>
          <p className="text-sm text-ink-400">Sign in to manage Event Story</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="mb-1.5 flex items-center gap-1.5 text-sm text-ink-300"><Mail size={14} /> Email</span>
            <input
              type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-2.5 text-sm text-white outline-none focus:border-brand"
            />
          </label>
          <label className="block">
            <span className="mb-1.5 flex items-center gap-1.5 text-sm text-ink-300"><Lock size={14} /> Password</span>
            <input
              type="password" required value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-2.5 text-sm text-white outline-none focus:border-brand"
            />
          </label>

          {error && <p className="text-sm text-danger">{error}</p>}

          <button type="submit" disabled={status === 'loading'} className="btn-primary w-full">
            {status === 'loading' ? <Loader2 size={18} className="animate-spin" /> : 'Sign In'}
          </button>
        </form>
        <p className="mt-5 text-center text-xs text-ink-500">
          Demo: admin@eventstory.in / admin123
        </p>
      </motion.div>
    </div>
  );
}
